import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router';

import type { Modal } from '@swf/core/models/modal';
import type { Dispatch } from '@swf/core/store';
import type { StaticContext } from '@swf/core/types/StaticContext';

const ModalRoute: React.FC<{ modal: Modal; staticContext?: StaticContext }> = ({
  modal,
  staticContext = {}
}) => {
  const {
    modal: { enqueue }
  } = useDispatch<Dispatch>();

  staticContext.prefetch = ({ dispatch }, options) => dispatch.page.fetchPage(options);

  useEffect(() => {
    enqueue(modal);
  });

  return <Redirect to="/" />;
};

export default ModalRoute;
